module.exports = "https://web-assets.ifttt.com/packs/media/feedback/thumbs-down-34c3b644.svg";